(function () {
  function initShopByFabricCarousel(root) {
    if (root.dataset.shopByFabricInitialized === 'true') {
      return;
    }

    var track = root.querySelector('[data-shop-by-fabric-track]');
    var prevButton = root.querySelector('[data-shop-by-fabric-prev]');
    var nextButton = root.querySelector('[data-shop-by-fabric-next]');
    var clearButtons = root.querySelectorAll('[data-shop-by-fabric-clear]');

    if (!track || !prevButton || !nextButton) {
      return;
    }

    root.dataset.shopByFabricInitialized = 'true';

    var scrollStep = parseInt(root.getAttribute('data-scroll-step'), 10) || 4;

    function revealSelectedFabric() {
      var selectedCard = track.querySelector('.shop-by-fabric__card--selected');

      if (!selectedCard) {
        return;
      }

      var cardLeft = selectedCard.offsetLeft;
      var cardRight = cardLeft + selectedCard.offsetWidth;
      var visibleLeft = track.scrollLeft;
      var visibleRight = visibleLeft + track.clientWidth;

      if (cardLeft < visibleLeft || cardRight > visibleRight) {
        var targetLeft = cardLeft - (track.clientWidth - selectedCard.offsetWidth) / 2;
        var maxScroll = track.scrollWidth - track.clientWidth;

        track.scrollTo({
          left: Math.max(0, Math.min(targetLeft, maxScroll)),
          behavior: 'smooth'
        });
      }
    }

    function getScrollAmount() {
      var card = track.querySelector('.shop-by-fabric__card');

      if (!card) {
        return track.clientWidth;
      }

      var styles = window.getComputedStyle(track);
      var gap = parseFloat(styles.columnGap || styles.gap) || 0;

      return (card.getBoundingClientRect().width + gap) * scrollStep;
    }

    function updateButtons() {
      var maxScroll = track.scrollWidth - track.clientWidth;
      var hasOverflow = maxScroll > 2;
      var atStart = track.scrollLeft <= 2;
      var atEnd = track.scrollLeft >= maxScroll - 2;

      root.classList.toggle('shop-by-fabric--no-overflow', !hasOverflow);
      prevButton.disabled = !hasOverflow || atStart;
      nextButton.disabled = !hasOverflow || atEnd;
    }

    prevButton.addEventListener('click', function () {
      track.scrollBy({ left: -getScrollAmount(), behavior: 'smooth' });
    });

    nextButton.addEventListener('click', function () {
      track.scrollBy({ left: getScrollAmount(), behavior: 'smooth' });
    });

    clearButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        var url = new URL(window.location.href);
        var filterParam = button.getAttribute('data-filter-param');

        if (!filterParam) {
          return;
        }

        url.searchParams.delete(filterParam);

        if (button.getAttribute('data-clear-availability') === 'true') {
          url.searchParams.delete('filter.v.availability');
        }

        window.location.href = url.toString();
      });
    });

    track.addEventListener('scroll', updateButtons, { passive: true });
    window.addEventListener('resize', function () {
      window.requestAnimationFrame(updateButtons);
    });

    updateButtons();
    revealSelectedFabric();
  }

  function initAll() {
    document.querySelectorAll('[data-shop-by-fabric]').forEach(initShopByFabricCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (event.target) {
      event.target.querySelectorAll('[data-shop-by-fabric]').forEach(initShopByFabricCarousel);
    }
  });
})();
